import { graphql } from "../../services/wp.api.service";

const query = `
	mutation MyMutation($token: String!) {
		validateRecaptcha(input: {token: $token}) {
			hostname
			success
			errorCodes
			challenge_ts
		}
	}
`;

export const verifyRecaptchaMutation = (useMutation, options) => useMutation(
	"verifyRecaptcha",
	(token) => graphql({
		query,
		variables: { token }
	}, true).
		catch((error) => {
			throw new Error(error);
		}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}
			return data.data.validateRecaptcha;
		}),
	{
		useErrorBoundary: true,
		...options
	}
);
